import React, {useEffect, useState} from "react";
import lbLeftside from '../../../resources/lbLeft.png';
import lbRightside from '../../../resources/lbRight.png';
import profilePicture from '../../../resources/profilePicture.png';

import {useLazyQuery} from "@apollo/client";
import {HOMEPAGE_LEADERBOARD, HOMEPAGE_LEADERBOARDPRIZES, LEADERBOARD_LASTSYNC} from "../../../queries/queries";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClock} from "@fortawesome/free-solid-svg-icons";
import {formatToCurrency, number_format} from "../../../helpers";
import Countdown, {zeroPad} from "react-countdown";
import moment from "moment";
import howlChip from "../../../resources/howlChip.png";
import howlCoinA from "../../../resources/howlCoinA.png";
import howlCoinB from "../../../resources/howlCoinB.png";

const HowlLeaderboard = () => {

    const [leaderboard, setLeaderboard] = useState([]);
    const [leaderboardPrizes, setLeaderboardPrizes] = useState([]);

    const [leaderboardRemaining, setLeaderboardRemaining] = useState([{PlayerName:'Tester', WageredAmount: 10000}]);
    const [leaderboardFirst, setLeaderboardFirst] = useState();
    const [leaderboardSecond, setLeaderboardSecond] = useState();
    const [leaderboardThird, setLeaderboardThird] = useState();
    const [nextResetTimestamp, setNextResetTimestamp] = useState(null);
    const [lastSyncTime, setLastSyncTime] = useState(null);

    const [getLeaderboard, {loading, refetch}] = useLazyQuery(HOMEPAGE_LEADERBOARD, {
        fetchPolicy: 'cache-and-network',
        onCompleted: (e) => {
            setLeaderboard(e.getLeaderboard);
        },
        onError: () => console.log("API Request failed - if this keeps happening, report to developer!")
    });
    //
    // const [getLeaderboardPrizes, {loadingPrize, refetchPrize}] = useLazyQuery(HOMEPAGE_LEADERBOARDPRIZES, {
    //     fetchPolicy: 'cache-and-network',
    //     onCompleted: (e) => {
    //         setLeaderboardPrizes(e.getLeaderboardPrizes);
    //     },
    //     onError: () => console.log("API Request failed - if this keeps happening, report to developer!")
    // });
    //
    // const [getLeaderboardLastSync, {loadingSync, refetchSync}] = useLazyQuery(LEADERBOARD_LASTSYNC, {
    //     fetchPolicy: 'cache-and-network',
    //     onCompleted: (e) => {
    //         setLastSyncTime(moment(e.getLatestSyncDate?.updatedAt * 1).fromNow());
    //     },
    //     onError: () => console.log("API Request failed - if this keeps happening, report to developer!")
    // });

    const getRewardAtPosition = position => {
        return leaderboardPrizes[position - 1] ? leaderboardPrizes[position - 1].Reward : '';
    };


    const renderer = ({formatted: {days, hours, minutes, seconds}, completed}) => {
        return <div className="cdWrapper">
            <div>
                <div className="cdValue">{zeroPad(days)}</div>
                <div className="cdText">Days</div>
            </div>
            <div>
                <div className="cdValue">{zeroPad(hours)}</div>
                <div className="cdText">Hours</div>
            </div>
            <div>
                <div className="cdValue">{zeroPad(minutes)}</div>
                <div className="cdText">Mins</div>
            </div>
            <div>
                <div className="cdValue">{zeroPad(seconds)}</div>
                <div className="cdText">Secs</div>
            </div>
        </div>;
    };

    useEffect(() => {
        if (leaderboard && leaderboard.length > 0) {
            setLeaderboardFirst(leaderboard.slice(0, 1)[0]);
            setLeaderboardSecond(leaderboard.slice(1, 2)[0]);
            setLeaderboardThird(leaderboard.slice(2, 3)[0]);
            setLeaderboardRemaining(leaderboard.slice(3, 50));
        }
    }, [leaderboard]);

    useEffect(() => {
        getLeaderboard();
        // getLeaderboardPrizes();
        // getLeaderboardLastSync();
        const timestamp = moment().utc().endOf('month');

        setNextResetTimestamp(timestamp.toDate());
    },[]);

    return (
        <div className={`fadeIn lb-howl`}>
            <img src={lbLeftside} alt="" className="leftside"/>
            <img src={lbRightside} alt="" className="rightside"/>

            <div className="lb-podium">
                <div className="entry">
                    {leaderboardSecond && <>
                        <div className="profileWrapper">
                            <div className="profilePictureWrapper">
                                <img src={leaderboardSecond.PlayerImage} className={`profilePicture`} alt=""/>
                            </div>
                            <div className={"positionWrapper"}>#2nd</div>
                            <p>{leaderboardSecond.PlayerName}</p>

                        </div>
                        <div className="wageredWrapper">
                        <p className="wageredText">Wagered</p>
                        <p className="wageredValue"><img src={howlChip} alt=""/> {number_format(leaderboardSecond.WageredAmount)}</p>
                    </div>
                    <div className="prizeWrapper">
                        <div className="prize">
                            20% <img src={howlChip} alt=""/>
                        </div>
                    </div>
                    </>}
                </div>

                <div className="entry gold">
                    {leaderboardFirst && <>
                        <div className="profileWrapper">
                            <div className="profilePictureWrapper">
                                <img src={leaderboardFirst.PlayerImage} className={`profilePicture`} alt=""/>
                            </div>
                            <div className={"positionWrapper"}>#1st</div>
                            <p>{leaderboardFirst.PlayerName}</p>

                        </div>
                        <div className="wageredWrapper">
                        <p className="wageredText">Wagered</p>
                        <p className="wageredValue"><img src={howlChip} alt=""/> {number_format(leaderboardFirst.WageredAmount)}
                        </p>
                    </div>
                    <div className="prizeWrapper">
                        <div className="prize">
                            30% <img src={howlChip} alt=""/>
                        </div>
                    </div>
                    </>}
                </div>

                <div className="entry bronze">
                    {leaderboardThird && <>
                    <div className="profileWrapper">
                        <div className="profilePictureWrapper">
                            <img src={leaderboardThird.PlayerImage} className={`profilePicture`} alt=""/>
                        </div>
                        <div className={"positionWrapper"}>#3rd</div>
                        <p>{leaderboardThird.PlayerName}</p>

                    </div>
                    <div className="wageredWrapper">
                        <p className="wageredText">Wagered</p>
                        <p className="wageredValue"><img src={howlChip} alt=""/> {number_format(leaderboardThird.WageredAmount)}
                        </p>
                    </div>
                    <div className="prizeWrapper">
                        <div className="prize">
                            15% <img src={howlChip} alt=""/>
                        </div>
                    </div>
                    </>}
                </div>
            </div>

            <div className="lb-countdown">
                <div className="countdownHeader"><FontAwesomeIcon icon={faClock} /> Time remaining</div>
                {nextResetTimestamp && <Countdown
                    zeroPadTime={1}
                    date={nextResetTimestamp}
                    renderer={renderer}
                />}

            </div>

            {lastSyncTime && <div className="lb-countdown">
                <div className="cdWrapper">
                    <div className="cdText">
                        Last updated {lastSyncTime}
                    </div>
                </div>
            </div>}

            <div className="lb-leaderboardRest">

                <div className="tableHeader">
                    <div className="name">User</div>
                    <div className="wagered">Wagered</div>
                    <div className="prize">Prize</div>
                </div>
                <div className="tableContent">
                    {leaderboardRemaining.map((entry, idx) =>
                    <div className="tableRow">
                        <div className="name">

                            <div className="playerPos">
                                #{idx + 4}
                            </div>
                            <div className="playerImage">
                                <img src={entry.PlayerImage} className={`profilePicture`} alt=""/>
                            </div>
                            <div className="playerName">
                                {entry.PlayerName}
                            </div>
                        </div>
                        <div className="wagered"><img src={howlChip} alt=""/> {number_format(entry.WageredAmount)}</div>
                        <div className="prize"><img src={howlChip} alt=""/> {number_format(getRewardAtPosition(idx + 4))}
                        </div>
                    </div>)}
                </div>

            </div>

        </div>
    )
}

export default HowlLeaderboard;